import type React from "react";
import { PlainTooltip } from "@similarweb/ui-components";
import { IconButton } from "@similarweb/ui-components";
import { i18nFilter } from "app/filters/i18nFilter";
import { swSettings } from "app/common/services/swSettings";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { AddToDashboardWrapper } from "./styles";

type AddToDashboardButtonProps = {
    onClick(): void;
    isDisabled?: boolean;
    tooltipContent?: string;
};

export const AddToDashboardButton: React.FC<AddToDashboardButtonProps> = ({ onClick, isDisabled, tooltipContent }) => {
    const { user } = swSettings;
    const isDashboardAvailable = !(proNavigator.isAccountReview() && user.hasSI);

    if (!isDashboardAvailable) {
        return null;
    }

    return (
        <PlainTooltip tooltipContent={i18nFilter()(tooltipContent ?? `common.addtodashboard.button.tooltip`)}>
            <div
                data-automation="Add To Dashboard"
                onClick={!isDisabled ? onClick : null}
            >
                <AddToDashboardWrapper
                    className="AddToDashboardWrapper"
                    isDisabled={isDisabled}
                >
                    <IconButton
                        isDisabled={isDisabled}
                        type="flat"
                        iconName="add"
                    />
                </AddToDashboardWrapper>
            </div>
        </PlainTooltip>
    );
};
